import dataConstants from "../_constants/dataConstants";

import { updateObject, mapArrayToObject } from "../_utils";
import userConstants from "../_constants/userConstants";
import { concat } from "lodash";

const initialState = {
  maritalStatus: {
    awaitingDivorce: {
      description: "Awaiting Divorce",
      label: "Awaiting Divorce",
      value: "awaitingDivorce"
    },
    divorced: {
      description: "Divorced",
      label: "Divorced",
      value: "divorced"
    },
    neverMarried: {
      description: "Never Married",
      label: "Never Married",
      value: "neverMarried"
    },
    widower: {
      description: "Widower",
      label: "Widower",
      value: "widower"
    }
  },
  bodyType: {
    athletic: {
      description: "Athletic",
      label: "Athletic",
      value: "athletic"
    },
    average: {
      description: "Average",
      label: "Average",
      value: "average"
    },
    heavy: {
      description: "heavy",
      label: "Heavy",
      value: "heavy"
    },
    slim: {
      description: "Slim",
      label: "Slim",
      value: "slim"
    }
  },
  complexion: {
    dark: {
      description: "Dark",
      label: "Dark",
      value: "dark"
    },
    fair: {
      description: "Fair",
      label: "Fair",
      value: "fair"
    },
    veryFair: {
      description: "Very Fair",
      label: "Very Fair",
      value: "veryFair"
    },
    wheatish: {
      description: "Wheatish",
      label: "Wheatish",
      value: "wheatish"
    }
  },
  diet: {
    eggetarian: {
      description: "Eggetarian",
      label: "Eggetarian",
      value: "eggetarian"
    },
    nonVeg: {
      description: "Non Veg",
      label: "Non Veg",
      value: "nonVeg"
    },
    vegan: {
      description: "Vegan",
      label: "Vegan",
      value: "vegan"
    },
    vegetarian: {
      description: "Vegetarian",
      label: "Vegetarian",
      value: "vegetarian"
    }
  },
  habitType: {
    no: {
      description: "No",
      label: "No",
      value: "no"
    },
    occasionally: {
      description: "Occasionally",
      label: "Occasionally",
      value: "occasionally"
    },
    yes: {
      description: "Yes",
      label: "Yes",
      value: "yes"
    }
  },
  jobType: {
    business: {
      description: "Business",
      label: "Business",
      value: "business"
    },
    civil: {
      description: "Civil Services",
      label: "Civil Services",
      value: "civil"
    },
    notWorking: {
      description: "Not Working",
      label: "Not Working",
      value: "notWorking"
    },
    private: {
      description: "Private Company",
      label: "Private Company",
      value: "private"
    },
    public: {
      description: "Government/Public Sector",
      label: "Government/Public Sector",
      value: "public"
    }
  },
  income: {
    "10To50": {
      description: "10 Lakh to 50 Lakh",
      label: "10 Lakh to 50 Lakh",
      value: "10To50"
    },
    "1To3": {
      description: "1 Lakh to 3 Lakh",
      label: "1 Lakh to 3 Lakh",
      value: "1To3"
    },
    "3To5": {
      description: "3 Lakh to 5 Lakh",
      label: "3 Lakh to 5 Lakh",
      value: "3To5"
    },
    "5To10": {
      description: "5 Lakh to 10 Lakh",
      label: "5 Lakh to 10 Lakh",
      value: "5To10"
    },
    greaterThan50: {
      description: "Greater Than 50 Lakh",
      label: "Greater Than 50 Lakh",
      value: "greaterThan50"
    },
    lessThan1: {
      description: "Less Than 1 Lakh",
      label: "Less Than 1 Lakh",
      value: "lessThan1"
    }
  },
  motherTongue: {
    assamese: {
      description: "Assamese",
      label: "Assamese",
      value: "assamese"
    },
    bengali: {
      description: "Bengali",
      label: "Bengali",
      value: "bengali"
    },
    bodo: {
      description: "Bodo",
      label: "Bodo",
      value: "bodo"
    },
    dogri: {
      description: "Dogri",
      label: "Dogri",
      value: "dogri"
    },
    gujarati: {
      description: "Gujarati",
      label: "Gujarati",
      value: "gujarati"
    },
    hindi: {
      description: "Hindi",
      label: "Hindi",
      value: "hindi"
    },
    kannada: {
      description: "Kannada",
      label: "Kannada",
      value: "kannada"
    },
    kashmiri: {
      description: "Kashmiri",
      label: "Kashmiri",
      value: "kashmiri"
    },
    konkani: {
      description: "Konkani",
      label: "Konkani",
      value: "konkani"
    },
    maithili: {
      description: "Maithili",
      label: "Maithili",
      value: "maithili"
    },
    malayalam: {
      description: "Malayalam",
      label: "Malayalam",
      value: "malayalam"
    },
    marathi: {
      description: "Marathi",
      label: "Marathi",
      value: "marathi"
    },
    meitei: {
      description: "Meitei",
      label: "Meitei",
      value: "meitei"
    },
    nepali: {
      description: "Nepali",
      label: "Nepali",
      value: "nepali"
    },
    odia: {
      description: "Odia",
      label: "Odia",
      value: "odia"
    },
    pubjabi: {
      description: "Pubjabi",
      label: "Pubjabi",
      value: "pubjabi"
    },
    santali: {
      description: "Santali",
      label: "Santali",
      value: "santali"
    },
    sindhi: {
      description: "Sindhi",
      label: "Sindhi",
      value: "sindhi"
    },
    tamil: {
      description: "Tamil",
      label: "Tamil",
      value: "tamil"
    },
    telugu: {
      description: "Telugu",
      label: "Telugu",
      value: "telugu"
    },
    urdu: {
      description: "Urdu",
      label: "Urdu",
      value: "urdu"
    }
  },
  education: {
    bPharm: {
      description: "B.Pharm",
      label: "B.Pharm",
      value: "bPharm"
    },
    bTech: {
      description: "B.E/B.Tech",
      label: "B.E/B.Tech",
      value: "bTech"
    },
    ba: {
      description: "B.A",
      label: "B.A",
      value: "ba"
    },
    bams: {
      description: "BAMS",
      label: "BAMS",
      value: "bams"
    },
    bba: {
      description: "BBA",
      label: "BBA",
      value: "bba"
    },
    bca: {
      description: "BCA",
      label: "BCA",
      value: "bca"
    },
    bcom: {
      description: "B.Com",
      label: "B.Com",
      value: "bcom"
    },
    bds: {
      description: "BDS",
      label: "BDS",
      value: "bds"
    },
    bed: {
      description: "B.Ed",
      label: "B.Ed",
      value: "bed"
    },
    bsc: {
      description: "B.Sc",
      label: "B.Sc",
      value: "bsc"
    },
    ca: {
      description: "CA",
      label: "CA",
      value: "ca"
    },
    diploma: {
      description: "Diploma",
      label: "Diploma",
      value: "diploma"
    },
    highSchool: {
      description: "High School",
      label: "High School",
      value: "highSchool"
    },
    llb: {
      description: "LLB",
      label: "LLB",
      value: "llb"
    },
    llm: {
      description: "LLM",
      label: "LLM",
      value: "llm"
    },
    mPharm: {
      description: "M.Pharm",
      label: "M.Pharm",
      value: "mPharm"
    },
    mTech: {
      description: "M.E/M.Tech",
      label: "M.E/M.Tech",
      value: "mTech"
    },
    ma: {
      description: "M.A",
      label: "M.A",
      value: "ma"
    },
    mba: {
      description: "MBA",
      label: "MBA",
      value: "mba"
    },
    mbbs: {
      description: "MBBS",
      label: "MBBS",
      value: "mbbs"
    },
    mca: {
      description: "MCA",
      label: "MCA",
      value: "mca"
    },
    mcom: {
      description: "M.Com",
      label: "M.Com",
      value: "mcom"
    },
    md: {
      description: "M.D",
      label: "M.D",
      value: "md"
    },
    mds: {
      description: "MDS",
      label: "MDS",
      value: "mds"
    },
    med: {
      description: "M.Ed",
      label: "M.Ed",
      value: "med"
    },
    msc: {
      description: "M.Sc",
      label: "M.Sc",
      value: "msc"
    },
    mse: {
      description: "M.S (Engineering)",
      label: "M.S (Engineering)",
      value: "mse"
    },
    msm: {
      description: "M.S (Medicine)",
      label: "M.S (Medicine)",
      value: "msm"
    },
    other: {
      description: "Other",
      label: "Other",
      value: "other"
    },
    phd: {
      description: "Ph.D",
      label: "Ph.D",
      value: "phd"
    }
  },
  employedIn: {
    agriculture: {
      description: "Agriculture",
      label: "Agriculture",
      value: "agriculture"
    },
    architecture: {
      description: "Architecture",
      label: "Architecture",
      value: "architecture"
    },
    arts: {
      description: "Arts",
      label: "Arts",
      value: "arts"
    },
    bma: {
      description: "Business Management and Administration",
      label: "Business Management and Administration",
      value: "bma"
    },
    communications: {
      description: "Communications",
      label: "Communications",
      value: "communications"
    },
    construction: {
      description: "Construction",
      label: "Construction",
      value: "construction"
    },
    educationTraining: {
      description: "Education And Training",
      label: "Education And Training",
      value: "educationTraining"
    },
    engineering: {
      description: "Engineering",
      label: "Engineering",
      value: "engineering"
    },
    finance: {
      description: "Finance",
      label: "Finance",
      value: "finance"
    },
    foodAndNatural: {
      description: "Food And Natural",
      label: "Food And Natural",
      value: "foodAndNatural"
    },
    govt: {
      description: "Government And Public Administration",
      label: "Government And Public Administration",
      value: "govt"
    },
    healthScience: {
      description: "Health Science",
      label: "Health Science",
      value: "healthScience"
    },
    hospitality: {
      description: "Hospitality And Tourism",
      label: "Hospitality And Tourism",
      value: "hospitality"
    },
    humanServices: {
      description: "Human Services",
      label: "Human Services",
      value: "humanServices"
    },
    it: {
      description: "Information Technology",
      label: "Information Technology",
      value: "it"
    },
    law: {
      description: "Law",
      label: "Law",
      value: "law"
    },
    manufacturing: {
      description: "Manufacturing",
      label: "Manufacturing",
      value: "manufacturing"
    },
    marketing: {
      description: "Marketing",
      label: "Marketing",
      value: "marketing"
    },
    other: {
      description: "Other",
      label: "Other",
      value: "other"
    },
    sales: {
      description: "Sales And Service",
      label: "Sales And Service",
      value: "sales"
    },
    security: {
      description: "Corrections And Security",
      label: "Corrections And Security",
      value: "security"
    },
    transportation: {
      description: "Transportation And Logistics",
      label: "Transportation And Logistics",
      value: "transportation"
    }
  },
  religion: {
    buddhist: {
      description: "Buddhist",
      label: "Buddhist",
      value: "buddhist"
    },
    christian: {
      description: "Christian",
      label: "Christian",
      value: "christian"
    },
    hindu: {
      description: "Hindu",
      label: "Hindu",
      value: "hindu"
    },
    jain: {
      description: "Jain",
      label: "Jain",
      value: "jain"
    },
    muslim: {
      description: "Muslim",
      label: "Muslim",
      value: "muslim"
    },
    noReligion: {
      description: "No Religion",
      label: "No Religion",
      value: "noReligion"
    },
    other: {
      description: "Other",
      label: "Other",
      value: "other"
    },
    sikh: {
      description: "Sikh",
      label: "Sikh",
      value: "sikh"
    }
  },
  community: {},
  caste: {
    any: {
      description: "Any Caste",
      label: "Any Caste",
      value: "any"
    },
    same: {
      description: "Same Caste",
      label: "Same Caste",
      value: "same"
    }
  },
  height: {
    "0": {
      description: "4ft",
      label: "4ft",
      value: "0"
    },
    "1": {
      description: "4ft 1in",
      label: "4ft 1in",
      value: "1"
    },
    "2": {
      description: "4ft 2in",
      label: "4ft 2in",
      value: "2"
    },
    "3": {
      description: "4ft 3in",
      label: "4ft 3in",
      value: "3"
    },
    "4": {
      description: "4ft 4in",
      label: "4ft 4in",
      value: "4"
    },
    "5": {
      description: "4ft 5in",
      label: "4ft 5in",
      value: "5"
    },
    "6": {
      description: "4ft 6in",
      label: "4ft 6in",
      value: "6"
    },
    "7": {
      description: "4ft 7in",
      label: "4ft 7in",
      value: "7"
    },
    "8": {
      description: "4ft 8in",
      label: "4ft 8in",
      value: "8"
    },
    "9": {
      description: "4ft 9in",
      label: "4ft 9in",
      value: "9"
    },
    "10": {
      description: "4ft 10in",
      label: "4ft 10in",
      value: "10"
    },
    "11": {
      description: "4ft 11in",
      label: "4ft 11in",
      value: "11"
    },
    "12": {
      description: "5ft",
      label: "5ft",
      value: "12"
    },
    "13": {
      description: "5ft 1in",
      label: "5ft 1in",
      value: "13"
    },
    "14": {
      description: "5ft 2in",
      label: "5ft 2in",
      value: "14"
    },
    "15": {
      description: "5ft 3in",
      label: "5ft 3in",
      value: "15"
    },
    "16": {
      description: "5ft 4in",
      label: "5ft 4in",
      value: "16"
    },
    "17": {
      description: "5ft 5in",
      label: "5ft 5in",
      value: "17"
    },
    "18": {
      description: "5ft 6in",
      label: "5ft 6in",
      value: "18"
    },
    "19": {
      description: "5ft 7in",
      label: "5ft 7in",
      value: "19"
    },
    "20": {
      description: "5ft 8in",
      label: "5ft 8in",
      value: "20"
    },
    "21": {
      description: "5ft 9in",
      label: "5ft 9in",
      value: "21"
    },
    "22": {
      description: "5ft 10in",
      label: "5ft 10in",
      value: "22"
    },
    "23": {
      description: "5ft 11in",
      label: "5ft 11in",
      value: "23"
    },
    "24": {
      description: "6ft",
      label: "6ft",
      value: "24"
    },
    "25": {
      description: "6ft 1in",
      label: "6ft 1in",
      value: "25"
    },
    "26": {
      description: "6ft 2in",
      label: "6ft 2in",
      value: "26"
    },
    "27": {
      description: "6ft 3in",
      label: "6ft 3in",
      value: "27"
    },
    "28": {
      description: "6ft 4in",
      label: "6ft 4in",
      value: "28"
    },
    "29": {
      description: "6ft 5in",
      label: "6ft 5in",
      value: "29"
    },
    "30": {
      description: "6ft 6in",
      label: "6ft 6in",
      value: "30"
    },
    "31": {
      description: "6ft 7in",
      label: "6ft 7in",
      value: "31"
    },
    "32": {
      description: "6ft 8in",
      label: "6ft 8in",
      value: "32"
    },
    "33": {
      description: "6ft 9in",
      label: "6ft 9in",
      value: "33"
    },
    "34": {
      description: "6ft 10in",
      label: "6ft 10in",
      value: "34"
    },
    "35": {
      description: "6ft 11in",
      label: "6ft 11in",
      value: "35"
    },
    "36": {
      description: "7ft",
      label: "7ft",
      value: "36"
    }
  },
  disability: {
    normal: {
      description: "Normal",
      label: "Normal",
      value: "normal"
    },
    physicallyChallenged: {
      description: "Physically Challenged",
      label: "Physically Challenged",
      value: "physicallyChallenged"
    }
  },
  familyStatus: {
    affluent: {
      description: "Affluent",
      label: "Affluent",
      value: "affluent"
    },
    middle: {
      description: "Middle",
      label: "Middle",
      value: "middle"
    },
    rich: {
      description: "Rich",
      label: "Rich",
      value: "rich"
    },
    upperMiddle: {
      description: "Upper Middle",
      label: "Upper Middle",
      value: "upperMiddle"
    }
  },
  familyValue: {
    liberal: {
      description: "Liberal",
      label: "Liberal",
      value: "liberal"
    },
    moderate: {
      description: "Moderate",
      label: "Moderate",
      value: "moderate"
    },
    orthodox: {
      description: "Orthodox",
      label: "Orthodox",
      value: "orthodox"
    },
    traditional: {
      description: "Traditional",
      label: "Traditional",
      value: "traditional"
    }
  },
  familyType: {
    joint: {
      description: "Joint",
      label: "Joint",
      value: "joint"
    },
    nuclear: {
      description: "Nuclear",
      label: "Nuclear",
      value: "nuclear"
    }
  },
  houseType: {
    own: {
      description: "Own",
      label: "Own",
      value: "own"
    },
    rent: {
      description: "Rent",
      label: "Rent",
      value: "rent"
    }
  },
  moonSign: {
    aquarius: {
      description: "Aquarius",
      label: "Aquarius",
      value: "aquarius"
    },
    aries: {
      description: "Aries",
      label: "Aries",
      value: "aries"
    },
    cancer: {
      description: "Cancer",
      label: "Cancer",
      value: "cancer"
    },
    capricorn: {
      description: "Capricorn",
      label: "Capricorn",
      value: "capricorn"
    },
    gemini: {
      description: "Gemini",
      label: "Gemini",
      value: "gemini"
    },
    leo: {
      description: "Leo",
      label: "Leo",
      value: "leo"
    },
    libra: {
      description: "Libra",
      label: "Libra",
      value: "libra"
    },
    pisces: {
      description: "Pisces",
      label: "Pisces",
      value: "pisces"
    },
    sagittarius: {
      description: "Sagittarius",
      label: "Sagittarius",
      value: "sagittarius"
    },
    scorpio: {
      description: "Scorpio",
      label: "Scorpio",
      value: "scorpio"
    },
    taurus: {
      description: "Taurus",
      label: "Taurus",
      value: "taurus"
    },
    virgo: {
      description: "Virgo",
      label: "Virgo",
      value: "virgo"
    }
  },
  createdBy: {},
  country: {},
  state: {}
};

/* ---------------------------------------------------
      GET MARITAL STATUS
  ----------------------------------------------------- */
const getMaritalStatus = (state, action) => {
  return updateObject(state, {
    maritalStatus: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET MOTHER TONGUE
  ----------------------------------------------------- */
const getMotherTongue = (state, action) => {
  return updateObject(state, {
    motherTongue: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET BODY TYPE
  ----------------------------------------------------- */
const getBodyType = (state, action) => {
  return updateObject(state, {
    bodyType: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET COMPLEXION
  ----------------------------------------------------- */
const getComplexion = (state, action) => {
  return updateObject(state, {
    complexion: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET DIET
  ----------------------------------------------------- */
const getDiet = (state, action) => {
  return updateObject(state, {
    diet: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET HABIT TYPE
  ----------------------------------------------------- */
const getHabitType = (state, action) => {
  return updateObject(state, {
    habitType: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET JOB TYPE
  ----------------------------------------------------- */
const getJobType = (state, action) => {
  return updateObject(state, {
    jobType: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET INCOME
  ----------------------------------------------------- */
const getIncome = (state, action) => {
  return updateObject(state, {
    income: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET EDUCATION
  ----------------------------------------------------- */
const getEducation = (state, action) => {
  return updateObject(state, {
    education: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET EMPLOYED IN
  ----------------------------------------------------- */
const getEmployedIn = (state, action) => {
  return updateObject(state, {
    employedIn: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET RELIGION
  ----------------------------------------------------- */
const getReligion = (state, action) => {
  return updateObject(state, {
    religion: mapArrayToObject(action.payload, "value")
  });
};

/* ---------------------------------------------------
      GET COMMUNITY BY RELIGION
  ----------------------------------------------------- */
const getCommunityByReligion = (state, action) => {
  return updateObject(state, {
    community: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET CASTE
  ----------------------------------------------------- */
const getCaste = (state, action) => {
  return updateObject(state, {
    caste: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET HEIGHT
  ----------------------------------------------------- */
const getHeight = (state, action) => {
  return updateObject(state, {
    height: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET DISABILITY
  ----------------------------------------------------- */
const getDisability = (state, action) => {
  return updateObject(state, {
    disability: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET FAMILY STATUS
  ----------------------------------------------------- */
const getFamilyStatus = (state, action) => {
  return updateObject(state, {
    familyStatus: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET FAMILY VALUE
  ----------------------------------------------------- */
const getFamilyValue = (state, action) => {
  return updateObject(state, {
    familyValue: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET FAMILY TYPE
  ----------------------------------------------------- */
const getFamilyType = (state, action) => {
  return updateObject(state, {
    familyType: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET HOUSE TYPE
  ----------------------------------------------------- */
const getHouseType = (state, action) => {
  return updateObject(state, {
    houseType: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET MOON SIGN
  ----------------------------------------------------- */
const getMoonSign = (state, action) => {
  return updateObject(state, {
    moonSign: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET CREATED BY
  ----------------------------------------------------- */
const getCreatedBy = (state, action) => {
  return updateObject(state, {
    createdBy: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET COUNTRY
  ----------------------------------------------------- */
const getCountry = (state, action) => {
  return updateObject(state, {
    country: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      GET STATE BY COUNTRY
  ----------------------------------------------------- */
const getStateByCountry = (state, action) => {
  return updateObject(state, {
    state: mapArrayToObject(action.payload, "value")
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};
/* ---------------------------------------------------
      CREATE COMMUNITY BY RELIGION
  ----------------------------------------------------- */
const createCommunityByReligion = (state, action) => {
  return updateObject(state, {
    community: updateObject(state.community, {
      [action.payload.value]: action.payload
    })
  });
};
/* ---------------------------------------------------
      REDUCER
  ----------------------------------------------------- */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case dataConstants.GET_MARITAL_STATUS:
      return getMaritalStatus(state, action);
    case dataConstants.GET_MOTHER_TONGUE:
      return getMotherTongue(state, action);
    case dataConstants.GET_BODY_TYPE:
      return getBodyType(state, action);
    case dataConstants.GET_COMPLEXION:
      return getComplexion(state, action);
    case dataConstants.GET_DIET:
      return getDiet(state, action);
    case dataConstants.GET_HABIT_TYPE:
      return getHabitType(state, action);
    case dataConstants.GET_JOB_TYPE:
      return getJobType(state, action);
    case dataConstants.GET_INCOME:
      return getIncome(state, action);
    case dataConstants.GET_EDUCATION:
      return getEducation(state, action);
    case dataConstants.GET_EMPLOYED_IN:
      return getEmployedIn(state, action);
    case dataConstants.GET_RELIGION:
      return getReligion(state, action);
    case dataConstants.GET_COMMUNITY_BY_RELIGION:
      return getCommunityByReligion(state, action);
    case dataConstants.GET_CASTE:
      return getCaste(state, action);
    case dataConstants.GET_HEIGHT:
      return getHeight(state, action);
    case dataConstants.GET_DISABILITY:
      return getDisability(state, action);
    case dataConstants.GET_FAMILY_STATUS:
      return getFamilyStatus(state, action);
    case dataConstants.GET_FAMILY_TYPE:
      return getFamilyType(state, action);
    case dataConstants.GET_FAMILY_VALUE:
      return getFamilyValue(state, action);
    case dataConstants.GET_HOUSE_TYPE:
      return getHouseType(state, action);
    case dataConstants.GET_MOON_SIGN:
      return getMoonSign(state, action);
    case dataConstants.GET_CREATED_BY:
      return getCreatedBy(state, action);
    case dataConstants.GET_COUNTRY:
      return getCountry(state, action);
    case dataConstants.GET_STATE_BY_COUNTRY:
      return getStateByCountry(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    case dataConstants.CREATE_COMMUNITY_BY_RELIGION:
      return createCommunityByReligion(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/dataReducer.js